export default (map, initialState) => {
  return (state, action) => {
    const reducer = map[action.type];
    if (typeof reducer === 'function') return reducer(state, action);
    return { ...initialState, ...state };
  };
};
